import { Component, inject, OnInit, output } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from 'sham-components/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App implements OnInit {
  private langService = inject(LanguageService);

  ngOnInit(): void {
    this.langService.init();
  }
  constructor() {}

  onclick = output({});
}
